import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/className';

const inputVariants = cva(
  'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-md border bg-background px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:text-foreground dark:placeholder:text-muted-foreground',
  {
    variants: {
      variant: {
        default:
          // "bg-background border-input text-foreground placeholder:text-muted-foreground dark:bg-background dark:border-input dark:text-foreground dark:placeholder:text-muted-foreground",
          'bg-fill-input-neutral-idle border-border-input-neutral-idle text-text-general-neutral-strong text-sm placeholder:text-text-general-neutral-muted',
        secondary:
          'bg-secondary border-secondary text-secondary-foreground placeholder:text-muted-foreground',
        accent:
          'bg-accent border-accent text-accent-foreground placeholder:text-muted-foreground',
        success:
          'bg-success border-success text-success-foreground placeholder:text-success-foreground/70',
        warning:
          'bg-warning border-warning text-warning-foreground placeholder:text-warning-foreground/70',
        destructive:
          'bg-destructive border-destructive text-destructive-foreground placeholder:text-destructive-foreground/70',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface InputProps
  extends React.ComponentProps<'input'>,
    VariantProps<typeof inputVariants> {}

function Input({ className, variant, type, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant, className }))}
      {...props}
    />
  );
}

export { Input };
